import { render, staticRenderFns } from "./PendingModule.vue?vue&type=template&id=da69badc"
import script from "./PendingModule.vue?vue&type=script&lang=js"
export * from "./PendingModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports